import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router'

import { useLoginUserMutation } from '../../services/apiSlice'
import { errorHandler } from '../../services/helpers'
import errorMessages from '../../utils/messages/errorMessages'
import Input from '../../components/forms/Input'
import ErrorDisplay from './ErrorDisplay'
import Spinner from '../../components/loading/Spinner'

const SignIn: React.FC = () => {
  const navigate = useNavigate()
  const [inputErrorFlags, setInputErrorFlags] = useState<number[]>([])
  const [errorMessage, setErrorMessage] = useState('')
  const [loginUser, { isSuccess, isLoading, isError, error }] =
    useLoginUserMutation()

  useEffect(() => {
    setInputErrorFlags([])
  }, [])

  useEffect(() => {
    if (isError) {
      const customError = errorHandler(error)
      console.log(customError)
      if (customError && customError.errorCode === 500) {
        setInputErrorFlags([0, 1])
        setErrorMessage(errorMessages['500-a'])
      }
      if (customError && customError.errorCode === 401) {
        setInputErrorFlags([0, 1])
        setErrorMessage(errorMessages['401-a'])
      }
      if (customError && customError.errorCode === 403) {
        setInputErrorFlags([0, 1])
        setErrorMessage(errorMessages['403-a'])
      }
      if (customError && customError.errorCode === 404) {
        setInputErrorFlags([0, 1])
        setErrorMessage(errorMessages['404-a'])
      }
      if (customError && customError.errorCode === 429) {
        setInputErrorFlags([0, 1])
        setErrorMessage(errorMessages['429'])
      }
    }

    if (isSuccess) {
      navigate('/home', { replace: true })
    }
  }, [isSuccess, isError, error, setInputErrorFlags, setErrorMessage, navigate])

  const handleLogin = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setInputErrorFlags([])
    const formData = new FormData(e.currentTarget)
    const email = formData.get('email') as string
    const password = formData.get('password') as string

    if (!email && !password) {
      setInputErrorFlags([0, 1])
      setErrorMessage(errorMessages.EMPTY_FORM)
      return
    }

    if (!email) {
      setInputErrorFlags([0])
      setErrorMessage(errorMessages.EMPTY_FORM)
      return
    }

    if (!password) {
      setInputErrorFlags([1])
      setErrorMessage(errorMessages.EMPTY_FORM)
      return
    }
    loginUser({ email, password })
  }

  return (
    <div className="flex h-full w-[650px] flex-col items-center justify-center">
      <form
        onSubmit={handleLogin}
        autoComplete="off"
        className="border-theme landing-dynamic-width flex h-[500px] flex-col items-center justify-center"
      >
        <div className="mb-[40px] w-full text-4xl font-bold">Sign in</div>
        <Input
          display={'Email'}
          type={'email'}
          name={'email'}
          min={8}
          max={100}
          showLimit={false}
          inputErrorFlag={inputErrorFlags.includes(0)}
        />
        <Input
          display={'Password'}
          type={'password'}
          name={'password'}
          min={8}
          max={100}
          showLimit={false}
          inputErrorFlag={inputErrorFlags.includes(1)}
        />
        <div className="mt-[15px] flex w-full flex-col">
          <button
            className="bgd-theme-wb text-main-invert h-[40px] w-full cursor-pointer rounded-full text-lg font-medium"
            type="submit"
          >
            Log in
          </button>
          <button
            className="bgd-blue mt-[10px] h-[40px] w-full cursor-pointer rounded-full text-lg font-medium text-white"
            type="button"
            onClick={() => {
              loginUser({
                email: 'usertesting@email.com',
                password: '11111111',
              })
            }}
          >
            Log in as Guest/Tester
          </button>
          {/* <button
            className="border-theme hover-main mt-[10px] h-[40px] w-full cursor-pointer rounded-full border text-lg font-medium text-inherit"
            type="submit"
          >
            Forgot Password?
          </button> */}
        </div>

        <ErrorDisplay errorMessage={errorMessage} />
        {isLoading && (
          <div className="mt-[20px] flex w-full items-center justify-center">
            <Spinner />
          </div>
        )}
      </form>
    </div>
  )
}

export default SignIn
